const UserTypes = {
    ADM: 'ADM',
    CLI: 'CLI',
    TEC: 'TEC',
    DEV: 'DEV',
}
export default UserTypes;